import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      background: 'var(--bg2)',
      borderTop: '1px solid rgba(99,179,237,0.08)',
      padding: '2rem 2rem',
      display: 'flex', justifyContent: 'space-between',
      alignItems: 'center', flexWrap: 'wrap', gap: '1rem',
      maxWidth: '100%',
    }}>
      <div>
        <div style={{ fontFamily: "'Syne', sans-serif", fontSize: '18px', fontWeight: '800', color: '#f0f4ff' }}>
          RS<span style={{ color: '#0ff4c6' }}>Courses</span>
        </div>
        <div style={{ fontSize: '12px', color: '#4a5878', marginTop: '4px' }}>© 2026 RSCourses. All rights reserved.</div>
      </div>
      <div style={{ display: 'flex', gap: '1.5rem' }}>
        {['Privacy', 'Terms', 'Blog', 'Careers'].map(l => (
          <a key={l} href="#" style={{ fontSize: '13px', color: '#4a5878', transition: 'color 0.15s' }}
            onMouseEnter={e => e.target.style.color = '#0ff4c6'}
            onMouseLeave={e => e.target.style.color = '#4a5878'}>
            {l}
          </a>
        ))}
      </div>
    </footer>
  );
}
